import { DropdownMenu } from '@hotjar/hotsauce';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigation } from '@hotjar/navigation/src/hooks/useNavigation';

interface AddNewSiteProps extends Pick<ComponentProps<typeof DropdownMenu.LinkItem>, 'onClick'> {
  className?: string;
}

export const AddNewSite = ({ className, onClick }: AddNewSiteProps): JSX.Element => {
  const { t } = useTranslation('navigation');
  const { routes, buildHrefFromRoute } = useNavigation();

  return (
    <DropdownMenu.LinkItem
      className={className}
      icon="plus"
      href={buildHrefFromRoute(routes.SITE.CREATE.path)}
      onClick={onClick}
    >
      {t('SiteSelector.addNewSite')}
    </DropdownMenu.LinkItem>
  );
};

AddNewSite.displayName = 'AddNewSite';
